// extracted by mini-css-extract-plugin
module.exports = {"global-header":"GlobalHeader_global-header__7RU_n"};